// @flow
import React from 'react'
import { Dialog } from 'components/Dialog'
import styles from './styles'

type Props = {
  account: Object,
  userRoles: Array<string>,
  onCancel: Function,
  onConfirm: Function,
}

const StatusDialog = ({ account, userRoles, onCancel, onConfirm }: Props) => {
  const [selectedStatus, setSelectedStatus] = React.useState('')

  const getAvailableStatusOptions = () => {
    if (!account || !account.status) {
      return []
    }

    const { status } = account
    const isStatusAdmin = userRoles && userRoles.includes('status_admin')

    const statusLabels = {
      approved: 'Active',
      suspended: 'Suspended',
      closing: 'Closing',
      closed: 'Closed',
    }

    let availableOptions = []

    if (status === 'approved') {
      availableOptions.push({ value: 'suspended', label: statusLabels.suspended })
      if (isStatusAdmin) {
        availableOptions.push({ value: 'closed', label: statusLabels.closed })
        availableOptions.push({ value: 'closing', label: statusLabels.closing })
      }
    } else if (status === 'suspended') {
      availableOptions.push({ value: 'approved', label: statusLabels.approved })
    } else if (status === 'closing' && isStatusAdmin) {
      availableOptions.push({ value: 'approved', label: statusLabels.approved })
    } else if (status === 'closed' && isStatusAdmin) {
      availableOptions.push({ value: 'approved', label: statusLabels.approved })
    }

    return availableOptions
  }

  const availableOptions = getAvailableStatusOptions()

  const handleConfirm = () => {
    if (selectedStatus && onConfirm) {
      onConfirm(selectedStatus)
    }
  }

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value)
  }

  const dialogBodyContent = (
    <div className={styles.sectionNoMargin}>
      <section className={styles.subSection}>
        <div className={styles.formItemMono}>
          <label className={styles.label} htmlFor="newStatus">
            Select New Status *
          </label>
          <select id="newStatus" name="newStatus" value={selectedStatus} onChange={handleStatusChange} className={styles.select} required>
            <option value="">Select Status</option>
            {availableOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </section>
    </div>
  )

  return (
    <Dialog
      headerText={`Change Account Status - ${account?.number || 'Unknown'}`}
      bodyText={dialogBodyContent}
      confirmButtonText="Update Status"
      cancelButtonText="Cancel"
      onConfirm={handleConfirm}
      onCancel={onCancel}
      disabled={!selectedStatus}
    />
  )
}

export default StatusDialog
